import React, {useEffect, useMemo, useState} from 'react';
import {withRouter} from 'react-router';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {createForm} from '@utils/forms';
import HeaderRenderer from '@appComponents/HeaderRenderer';
import {RenderBackToListButton} from '@appComponents/ButtonCollection';
import {convertToInt, isUrlParamValid} from '@utils/helpers';
import {showErrorModal} from '@utils/modal';
import navigation from '@constants/navigation';
import mapModulesToProps from '@utils/mapModulesToProps';
import {getLink} from '@appComponents/Link';
import {routes} from '@constants/routes';

import SpiideoVenueMappingModel from '../forms/SpiideoVenueMappingModel';
import SpiideoVenueMappingForm from '../forms/SpiideoVenueMappingForm';

export const SpiideoVenuesEdit = ({
    match: {
        params: {id = null},
    },
    Menu,
}) => {
    const [pageTitle, setPageTitle] = useState(null);

    useEffect(() => {
        Menu?.storeMenu(navigation.infrastructure.key);

        document.title = id ? routes.spiideoMappings.venues.title : routes.spiideoMappings.venuesAdd.title;

        return () => {document.title = 'AVCMP';};
    }, [id]);

    if (id && !isUrlParamValid(id)) {
        showErrorModal({
            header: 'Error',
            redirectLink: getLink('spiideoMappings.venues', {id: id}),
            text: 'Spiideo venue not found.',
            errorButtonIcon: 'arrow circle left',
            errorButtonText: 'Back to the list',
        });
    }

    const Form = useMemo(() => (
        createForm(
            SpiideoVenueMappingModel,
            SpiideoVenueMappingForm, {
                id: convertToInt(id),
                setPageTitle: setPageTitle,
            }
        )
    ), [id]);

    return (
        <div>
            <HeaderRenderer
                buttons={RenderBackToListButton}
                buttonsProps={{name: 'spiideoMappings.venues'}}
                messagesBoxNames='spiideoVenueMappingMessageError'
                pageTitle={pageTitle}
            />
            <Form/>
        </div>
    );
};

SpiideoVenuesEdit.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            id: PropTypes.string,
        }),
    }).isRequired,
    Menu: PropTypes.object,
};

SpiideoVenuesEdit.displayName = 'SpiideoVenuesEdit';

export default connect(null, mapModulesToProps(['Menu']))(withRouter(SpiideoVenuesEdit));
